import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { partners } from '../data/mock';

const Partners = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });
  
  // Duplicate partners array for seamless infinite scroll
  const duplicatedPartners = [...partners, ...partners, ...partners, ...partners];

  return (
    <section className="partners-section" ref={ref}>
      <div className="partners-container">
        {/* Section Header */}
        <motion.div 
          className="section-header"
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          <motion.span 
            className="section-tag"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={isInView ? { opacity: 1, scale: 1 } : {}}
            transition={{ delay: 0.2 }}
            style={{ opacity: isInView ? 1 : 0 }}
          >
            Our Partners
          </motion.span>
          <motion.h2 
            className="section-title"
            initial={{ opacity: 0, y: 20 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ delay: 0.3 }}
            style={{ opacity: isInView ? 1 : 0 }}
          >
            Trusted
            <span className="gradient-text"> Partnerships</span>
          </motion.h2>
          <motion.p 
            className="section-subtitle"
            initial={{ opacity: 0 }}
            animate={isInView ? { opacity: 1 } : {}}
            transition={{ delay: 0.4 }}
            style={{ opacity: isInView ? 1 : 0 }}
          >
            Collaborating with industry leaders to deliver excellence
          </motion.p>
        </motion.div>

        {/* Partners Marquee */}
        <motion.div 
          className="partners-marquee"
          initial={{ opacity: 0 }}
          animate={isInView ? { opacity: 1 } : {}}
          transition={{ delay: 0.5 }}
        >
          <div className="partners-track">
            {duplicatedPartners.map((partner, index) => (
              <motion.div 
                key={`${partner.id}-${index}`} 
                className="partner-card"
                whileHover={{ 
                  y: -8, 
                  boxShadow: '0 20px 50px rgba(59, 130, 246, 0.2)',
                  borderColor: '#3b82f6'
                }}
                transition={{ type: 'spring', stiffness: 200 }}
                data-testid={`partner-card-${partner.id}`}
              >
                <motion.div 
                  className="partner-logo"
                  whileHover={{ scale: 1.05 }}
                >
                  <img 
                    src={partner.image} 
                    alt={partner.shortName}
                    className="partner-logo-img"
                    loading="lazy"
                  />
                </motion.div>
                <div className="partner-info">
                  <h4 className="partner-name">{partner.shortName}</h4>
                  <span className="partner-category">{partner.category}</span>
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Partners;
